import { PatientActions } from 'src/redux/actions/constant';

const {
  RESET_DEACTIVATE_PATIENT,
  LOADING_DEACTIVATE_PATIENT,
  SUCCESS_DEACTIVATE_PATIENT,
  FAILURE_DEACTIVATE_PATIENT,
} = PatientActions;

const intitialstate: object = {
  isPatientDeactivated: false,
  response: null,
  loading: false,
};

export const deactivatePatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_DEACTIVATE_PATIENT: {
      return {
        ...state,
        isPatientDeactivated: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_DEACTIVATE_PATIENT:
      return {
        ...state,
        isPatientDeactivated: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_DEACTIVATE_PATIENT:
      return {
        ...state,
        loading: true,
      };

    case RESET_DEACTIVATE_PATIENT:
      return intitialstate;

    default:
      return state;
  }
};
